export const getCascaderStyles = () =>
  ({
    cascaderContainer: {
      top: 'auto',
      width: 'fit-content',
      padding: '10px 15px',
      border: '1px solid #606060',
    },

    searchboxContainer: {
      width: '225px',
      position: 'relative',
      marginBottom: '10px',
    },

    selectorContainer: {
      display: 'flex',
    },

    selectorBox: {
      flex: 1,
      minWidth: '300px',
    },
  });
